import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href"]

import { ref, computed } from 'vue';
import { notification } from '@/js/lib/ui';
import IModal from '@/js/components/molecules/IModal.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'share',
  props: {
    title: { default: '' },
    url: { default: '' },
    buttonLabel: { default: 'シェア' }
  },
  setup(__props: any) {

const props = __props;
const active = ref(false);
const urlForFacebook = computed(() => {
  const url = 'https://www.facebook.com/sharer/sharer.php';
  const params = new URLSearchParams();

  params.append('u', props.url);

  return `${url}?${params.toString()}`;
});
const urlForTwitter = computed(() => {
  const url = 'https://x.com/intent/tweet';
  const params = new URLSearchParams();

  params.append('url', props.url);
  params.append('related', 'iichi_Japan');
  params.append('via', 'iichi_Japan');

  if (props.title) {
    params.append('text', props.title);
  }

  return `${url}?${params.toString()}`;
});
const urlForLine = computed(() => {
  const url = 'https://social-plugins.line.me/lineit/share';
  const params = new URLSearchParams();

  params.append('url', props.url);

  return `${url}?${params.toString()}`;
});
const onClickFacebookButton = () => {
  window.open(urlForFacebook.value, '', 'width=650,height=450,menubar=no,toolbar=no,scrollbars=yes');
};
const onClickTwitterButton = () => {
  window.open(urlForTwitter.value, '', 'width=650,height=450,menubar=no,toolbar=no,scrollbars=yes');
};
const onClickLineButton = () => {
  window.open(urlForLine.value, '', 'width=650,height=450,menubar=no,toolbar=no,scrollbars=yes');
};
const onClickCopyButton = async () => {
  if (navigator.clipboard) {
    await navigator.clipboard.writeText(props.url);
    notification('リンクをコピーしました');
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$style.share)
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style.trigger),
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (active.value = true), ["prevent"]))
    }, [
      _createElementVNode("span", null, _toDisplayString(_ctx.buttonLabel), 1)
    ], 2),
    _cache[9] || (_cache[9] = _createTextVNode()),
    _createVNode(IModal, {
      modelValue: active.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((active).value = $event)),
      width: "300px"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.$style.modalContent)
        }, [
          _createElementVNode("div", {
            class: _normalizeClass([_ctx.$style.button, _ctx.$style.shareFacebook]),
            onClick: _withModifiers(onClickFacebookButton, ["prevent"])
          }, _cache[2] || (_cache[2] = [
            _createElementVNode("span", null, "シェアする", -1)
          ]), 2),
          _cache[6] || (_cache[6] = _createTextVNode()),
          _createElementVNode("div", {
            class: _normalizeClass([_ctx.$style.button, _ctx.$style.shareTwitter]),
            onClick: _withModifiers(onClickTwitterButton, ["prevent"])
          }, _cache[3] || (_cache[3] = [
            _createElementVNode("span", null, "Xに投稿する", -1)
          ]), 2),
          _cache[7] || (_cache[7] = _createTextVNode()),
          _createElementVNode("div", {
            class: _normalizeClass([_ctx.$style.button, _ctx.$style.shareLine]),
            onClick: _withModifiers(onClickLineButton, ["prevent"])
          }, _cache[4] || (_cache[4] = [
            _createElementVNode("span", null, "LINEで送る", -1)
          ]), 2),
          _cache[8] || (_cache[8] = _createTextVNode()),
          _createElementVNode("a", {
            class: _normalizeClass([_ctx.$style.button, _ctx.$style.shareLink]),
            href: _ctx.url,
            onClick: _withModifiers(onClickCopyButton, ["prevent"])
          }, _cache[5] || (_cache[5] = [
            _createElementVNode("span", null, "リンクをコピー", -1)
          ]), 10, _hoisted_1)
        ], 2)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 2))
}
}

})